<template>
    <v-card class="card-container">
        <v-card-title>
            <v-row no-gutters>
                <v-col>
                    <v-text-field
                            class="search-block"
                            v-model="search"
                            prepend-inner-icon="mdi-magnify"
                            single-line
                            solo
                            placeholder="Поиск"
                            dense
                            hide-details
                    />
                </v-col>
                <v-spacer></v-spacer>

            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
            <v-data-table
                    :loading="loading"
                    no-data-text="Нет элементов"
                    no-results-text="Не найдено элементов"
                    loading-text="Загрузка данных"
                    calculate-widths
                    :items-per-page="filteredItems.length"
                    :items="filteredItems"
                    :headers="fields"
                    :search="search"
                    height="100%"
                    hide-default-footer
                    class="elevation-1 h-100 px-2"
            >

                <template v-slot:item.applyDate="{item}">
                    <span>{{formatDateMounthName(item.applyDate)}}</span>
                </template>


            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "ClientInfoActivates",
        props:{
            item:Object,

        },
        data(){
            return {
                search:null,
                loading:null,
                fields:[
                    {text: 'Бонус', value: 'bonus'},
                    {text: 'Партнер', value: 'organization'},
                    {text: 'Адрес', value: 'orgGeoInfo'},
                    {text: 'Списал', value: 'webUser'},
                    {text: 'Дата списания', value: 'applyDate'},
                ]
            }
        },
        mounted(){
            this.$store.dispatch("Clients/getClientActivations", this.item.id).catch(err=>{
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка активаций!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })
        },
        computed:{
            filteredItems(){
                return this.$store.state.Clients.activates
            },

            allBonusesCount(){
                return '0/0'
            }
        },
        methods:{

        }
    }
</script>

<style scoped>
    .bonus-count-label {
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;

    }

    .bonus-count-info {
        font-weight: 600;
        font-size: 24px;
        line-height: 40px;
        color: #000000;
    }
</style>